import { render, staticRenderFns } from "./CheckboxSingleReadOnly.vue?vue&type=template&id=4f65f7ba&"
import script from "./CheckboxSingleReadOnly.vue?vue&type=script&lang=js&"
export * from "./CheckboxSingleReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f65f7ba')) {
      api.createRecord('4f65f7ba', component.options)
    } else {
      api.reload('4f65f7ba', component.options)
    }
    module.hot.accept("./CheckboxSingleReadOnly.vue?vue&type=template&id=4f65f7ba&", function () {
      api.rerender('4f65f7ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/checkbox-single/CheckboxSingleReadOnly.vue"
export default component.exports